<template>
  <div class="pt-6 pb-10 text-center border-2 border-black rounded-lg bg-opacity-default">
    <h1 class="mb-0">Se connecter</h1>
    <form @submit.prevent="login()" class="justify-center p-grid">
      <div class="p-col-10">
        <div class="my-8">
          <div class="text-left p-field">
            <label for="login_email">Adresse mail ou identifiant</label>
            <div class="p-inputgroup">
              <InputText
                id="login_email"
                v-model="form.email"
                type="text"
                placeholder="tom@farcie.com"
                class="w-full p-inputtexte"
              />
            </div>

            <div class="errors" v-if="errors.email">
              <Message severity="error">
                <p v-for="(error, key) in errors.email" :key="key">
                  {{ error }}
                </p>
              </Message>
            </div>
          </div>
          <div class="text-left p-field">
            <label for="login_password">Mot de passe</label>
            <div class="flex">
              <div class="p-inputgroup">
                <InputText
                  id="login_password"
                  v-model="form.password"
                  :type="visible_password ? 'text' : 'password'"
                  placeholder="*****"
                  class="w-full"
                />
              </div>


            </div>

            <div class="errors" v-if="errors.password">
              <Message severity="error">
                <p v-for="(error, key) in errors.password" :key="key">
                  {{ error }}
                </p>
              </Message>
            </div>
          </div>
          <!--
          <div class="text-right">
            <router-link class="link" :to="{ name: 'PasswordReset' }">
              <span>Mot de passe oublié ?</span>
            </router-link>
          </div>
          -->
        </div>

        <div class="flex justify-end">
          <Button
            type="submit"
            class="btn-green"
            label="Se connecter"
            :is-loading="isLoggingIn"
          />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Button from "../Button"

export default {
  components: {
    Button
  },
  data: () => ({
    form: {
      email: "",
      password: "",
    },
    visible_password: false,
    errors: [],
    isLoggingIn: false,
  }),
  methods: {
    ...mapActions({
      loginStore: "auth/login",
    }),
    login() {
      this.isLoggingIn = true;
      this.loginStore(this.form)
        .then((isAdmin) => {
          if (isAdmin) {
            this.$router.push({ name: "Admin Dashboard" });
          } else {
            this.$router.push({ name: "Dashboard" });
          }
        })
        .catch((errors) => {
          this.errors = errors;
        })
        .finally(() => {
          this.isLoggingIn = false;
        });
    },
    togglePasswordVisibility() {
      this.visible_password = !this.visible_password;
    },
  },
};
</script>
